import { render, staticRenderFns } from "./IconDate.vue?vue&type=template&id=4f49887f"
import script from "./IconDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconDate.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports